export default __webpack_public_path__ + "static/media/kitchen2.1b4cdb5c.png";